import { convertGQLToProductJson } from 'utils/general'

/**
 * @info
 *
 * *The "store/shade-finder" directory*
 * This "store" directory declares each of the Vuex
 * modules that all together power the site. Here, we have the
 * Vuex store module that sits behind product functionality.
 *
 * *This file*
 * This file outlines "mutations". Mutations are intended
 * to be as simple as possible. All modifications to the state
 * object should happen inside a mutation function. Each
 * of these functions must be synchronous. There should be nothing
 * that has a time delay, such as an AJAX request or a setTimeout.
 */

export default {
  setQuizSkinTone (state, skinTone) {
    state.quiz.skinTone = skinTone
  },
  setQuizStep (state, step) {
    state.quiz.step = step
  },
  setQuizPushScore (state, score) {
    state.quiz.scores.push(score)
  },
  setQuizPopScore (state) {
    state.quiz.scores.pop()
  },
  resetQuiz (state) {
    const quiz = {
      step: 1,
      skinTone: '',
      scores: []
    }
    Object.assign(state.quiz, quiz)
  },
  setActiveCategory (state, value) {
    state.activeCategory = value
  },
  setState (state, { key, value }) {
    state[key] = value
  }
}
